import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import { SearchAPI } from "@/api/search";
import { useColorScheme } from "@/hooks/useColorScheme";
import { AsyncSelect } from "@/components/Select";
import BrowserOnly from "@/components/BrowserOnly";

const ServiceAutocomplete = (props) => {
  const colorScheme = useColorScheme();
  return (
    <S.InputWrap>
      <BrowserOnly>
        <AsyncSelect
          isClearable
          onFocus={props.onFocus}
          value={
            props.service
              ? {
                  label: props.service,
                  value: props.service,
                }
              : null
          }
          id="search-service"
          classNamePrefix="masters-search-autocomplete"
          onChange={(v) => {
            props.onChange(v?.label);
          }}
          noOptionsMessage={() => props.t("common:empty")}
          cacheOptions
          placeholder={props.t("common:search_form.service")}
          loadingMessage={() => props.t("common:loading")}
          loadOptions={async (input) => {
            const { data } = await SearchAPI.autocomplete({
              query: input,
            });
            return data.map(({ title }) => ({
              label: title,
              value: title,
            }));
          }}
        />
      </BrowserOnly>
      <S.SearchIcon
        color={colorScheme === "dark" ? "#fff" : "#d1179e"}
        width="20"
      />
    </S.InputWrap>
  );
};
ServiceAutocomplete.propTypes = {
  service: PT.string,

  onFocus: PT.func.isRequired,
  onChange: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default ServiceAutocomplete;
